// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const invoiceSummarySelector = (state: ApplicationState) => {
    return state.bunzl.pages.invoiceSummaryReportData?.invoiceSummaryReportData;
};

export const invoiceDetailReportDataSelector = (state: ApplicationState) => {
    return state.bunzl.pages.InvoiceDetail.invoiceDetailReportData;
};

export const validationErrorSelector = (state: ApplicationState) => {
    return state.bunzl.pages.ReportAPI.validationError;
};

export const poErrorSelector = (state: ApplicationState) => {
    return state.bunzl.pages.ReportAPI.poError;
};
